module.exports = __webpack_public_path__ + "img/IMAGE 7.91855bc3.png";